import { createAction } from 'redux-actions';
export var SET_PRICE = 'SET_PRICE';
export var PriceBreakdownType;
(function (PriceBreakdownType) {
    PriceBreakdownType["Total"] = "Order";
    PriceBreakdownType["Service"] = "Service";
    PriceBreakdownType["Upsale"] = "Upsale";
})(PriceBreakdownType || (PriceBreakdownType = {}));
export var setBreakdownPrices = createAction(SET_PRICE, function (priceBreakdown) { return priceBreakdown; });
